import { useEffect } from 'react';

import { useAppDispatch } from 'app/hooks';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { fetchLicenses } from 'common/services/api/Licenses/Licenses.thunk';
import { License } from 'common/types/Entities';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { clearLicenses } from 'features/licenses/licensesSlice';
import { useSnackbar } from 'notistack';

type onChangeHandler = (licenses: License[]) => void;

export const useFetchLicensesByTenantId = (onChange: onChangeHandler, tenantId: string) => {
    const dispatch = useAppDispatch();

    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        if(tenantId) {
            dispatch(fetchLicenses({ tenantId }))
                .unwrap()
                .catch(error => {
                    dispatch(clearLicenses());
                    onChange([]);
                    handleListFetchError(extractStatusCode(error.message), 'License', enqueueSnackbar);
                });

        } else {
            dispatch(clearLicenses());
            onChange([]);
        }
    }, [tenantId]);
};
